import React from 'react';
import { PauseIcon as HeroPauseIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type PauseIconProps = Omit<IconProps, 'children'>;

export const PauseIcon: React.FC<PauseIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroPauseIcon />
        </Icon>
    );
};
